import { Text, Form, useWizardContext, Wizard, Button } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import { emailSchema } from '../schema'
import { StepLayout } from '../StepLayout'
import { FittingRoomValues } from '../types'
import { useFittingRoomContext } from '../FittingRoomProvider'

export const EmailCollection = () => {
  const { t } = useTranslation()

  const { returnTo } = useFittingRoomContext()
  const { values } = useWizardContext<FittingRoomValues>()

  const { loungeFit } = values

  return (
    <Wizard.Step validationSchema={emailSchema}>
      <StepLayout
        title={
          loungeFit?.inStock
            ? t('fitting_room.email_collection.in_stock.title')
            : t('fitting_room.email_collection.no_stock.title')
        }
        subtitle={
          <div className="flex">
            <div>
              {loungeFit?.inStock
                ? t('fitting_room.email_collection.in_stock.subtitle')
                : t('fitting_room.email_collection.no_stock.subtitle')}
            </div>

            <Text className="flex-grow-1 whitespace-nowrap ml-8 md:ml-16">
              {t('general.x_of_y', { x: 2, y: 2 })}
            </Text>
          </div>
        }
        showProgress={false}
      >
        <div className="flex flex-col gap-4 [&>div]:w-full">
          <Form.Input name="email" label={t('account.email_address')} />
          <Form.Checkbox
            className="justify-start"
            name="acceptsMarketing"
            label={t('account.marketing_opt_in')}
          />
        </div>
        {loungeFit?.inStock ? (
          <Form.Submit size="lg" className="mt-4 w-full">
            {t('action.submit')}
          </Form.Submit>
        ) : (
          <Button as="a" href={returnTo} size="lg" className="mt-4 w-full">
            {t('action.submit')}
          </Button>
        )}
      </StepLayout>
    </Wizard.Step>
  )
}
